import React, { useEffect } from 'react';

export default function FinanciamentoEntreParticularesPage() {
  useEffect(() => {
    window.location.href = `./`;
  }, []);
  return <>{/*  */}</>;
}
